import {
    LOAD_WORK_INSTRUCTION,
} from '../actions/wi_actions';

const author_reducer = (oldState = {}, action) => {
    Object.freeze(oldState);
    switch (action.type) {
        case LOAD_WORK_INSTRUCTION:
            return action.workInstruction
        default:
            return oldState;
    }
};

export default author_reducer;